import Joi from "joi-browser";

const JoiInstance = Joi.extend(joi => ({
  base: joi.string().valid(Joi.ref("password")),
  name: "resetPassword",
  coerce(value, state, options) {
    const {
      parent: { password },
    } = state;
    if (value !== password) {
      return this.createError("resetPassword.invalid", {}, state, options);
    }
    return value;
  },
}));
// Any character is allowed; the policy is 8 to 32 characters with at least
// one number. The regex is named so the form can show a message describing
// that rule instead of the generic "invalid characters" one.
const newPasswordValidation = Joi.string()
  .regex(/^(?=.*\d).{8,32}$/, "password")
  .required();

export default Joi.object({
  // The API only compares the old password against the stored hash, it never
  // checks its format. Applying the new password policy here would lock out
  // every user whose current password predates the policy.
  oldPassword: Joi.string().required(),
  password: newPasswordValidation,
  passwordConfirmation: JoiInstance.resetPassword().required(),
});
